<div class="mon-dialog-header">
    <div class="row">
        <div class="col-48" [class.outer-t-smurf]="pushHeader">
            <page-header [header]="('New rule' | translate) + ' - ' + ruleType.translation"
                         [subHeader]="ruleType.description"
                         [subHeaderTooltipEnable]="false"
                         [panelLeftClass]="'col-48 ' + headerClass"
                         *ngIf="!rule.name">
            </page-header>
            <page-header [header]="('Edit rule' | translate) + ' - ' + ruleType.translation"
                         [subHeader]="ruleType.description"
                         [panelLeftClass]="'col-48 ' + headerClass"
                         [subHeaderTooltipEnable]="false"
                         *ngIf="rule.name">
            </page-header>
        </div>
    </div>
</div>

<form-global-policy-dialog-rule-readability [monDialogId]="monDialogId"
                                            [cRule]="cRule"
                                            *ngIf="cRule.type === 'readability_level'">
</form-global-policy-dialog-rule-readability>
<form-global-policy-dialog-rule-file-size [monDialogId]="monDialogId"
                                          [cRule]="cRule"
                                          *ngIf="cRule.type === 'file_size'">
</form-global-policy-dialog-rule-file-size>
<form-global-policy-dialog-rule-image-size [monDialogId]="monDialogId"
                                           [cRule]="cRule"
                                           *ngIf="cRule.type === 'image_size'">
</form-global-policy-dialog-rule-image-size>
<form-global-policy-dialog-rule-standard [monDialogId]="monDialogId"
                                         [cRule]="cRule"
                                         *ngIf="standardBlacklist.indexOf(cRule.type) === -1">
</form-global-policy-dialog-rule-standard>
<form-global-policy-dialog-rule-count-rule [monDialogId]="monDialogId"
                                           [cRule]="cRule"
                                           *ngIf="countList.indexOf(cRule.type) > -1">
</form-global-policy-dialog-rule-count-rule>

<form-global-policy-dialog-rule-meta-header [monDialogId]="monDialogId"
                                            [cRule]="cRule"
                                            *ngIf="cRule.type === 'meta_header'">
</form-global-policy-dialog-rule-meta-header>

<form-global-policy-dialog-rule-meta-header-length [monDialogId]="monDialogId"
                                                   [cRule]="cRule"
                                                   *ngIf="cRule.type === 'meta_header_length'">
</form-global-policy-dialog-rule-meta-header-length>
